import { render } from "./MeetingTranscript.vue?vue&type=template&id=944dde44&scoped=true"
import script from "./MeetingTranscript.vue?vue&type=script&lang=js"
export * from "./MeetingTranscript.vue?vue&type=script&lang=js"

import "./MeetingTranscript.vue?vue&type=style&index=0&id=944dde44&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-944dde44"]])

export default __exports__